import theme from '@styles/theme';
export default {
  section: (background?: string) => ({
    background,
    p: ['0 0 64px', '0 0 64px', '0 0 80px', '0 0 80px', 0],
    display: 'flex',
    justifyContent: ['space-around', 'space-around', 'space-around', 'space-around', 'space-between'],
    alignItems: 'center',
    flexDirection: ['column-reverse', 'column-reverse', 'column-reverse', 'column-reverse', 'row'],
    flexWrap: ['wrap', 'wrap', 'wrap', 'wrap', 'nowrap'],
    position: 'relative',
    zIndex: theme.zIndex.documentUp + 1,
    minHeight: ['auto', 'auto', 'auto', 'auto', '48.8888889vw', '46.875vw']
  }),
  description: (color?: string) => ({
    maxWidth: ['100%', '100%', '100%', '100%', '18.6111111vw', '18.8541667vw'],
    width: '100%',
    textAlign: 'left',
    ml: ['0', '0', '0', '0', '6.94444444vw', '6.25vw'],
    padding: ['64px 40px 0 40px', '64px 40px 0 40px', '64px 64px 0 64px', '64px 64px 0 64px', 0],
    'p, h1': {
      color: `${color}` || 'neutralBlack',
      p: ['0 0 40px', '0 0 40px', '0px 0 24px', '0px 0 24px', '0 0 40px'],
      fontSize: 16,
      width: ['100%', '100%', '100%', '100%', '14.4444444vw', '12.6041667vw'],
      maxWidth: ['100%', '100%', '100%', '100%', '208px', '242px'],
      textTransform: 'none',
      fontFamily: theme.fonts.uniform,
      fontWeight: theme.fontWeights.normal,
      letterSpacing: 0,
      lineHeight: '140%'
    },
    'h1, h2': {
      pb: '16px'
    }
  })
};